import { Button } from "../Buttons";
import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from "../Loader";
import styled from 'styled-components';
import { BaseComponent } from "../BaseComponent";
import { InlineWarning } from "../Warnings";

const Row = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`

export class InlineActionConfirm extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            confirm: false
        }
    }

    confirm() {
        this.updateState('confirm', false);
        this.props.onConfirm(true);
    }

    renderConfirm() {
        return <InlineWarning>
            <span className="text">
                {this.props.confirmText || ''}
            </span>
            <Button isPrimary onClick={this.confirm.bind(this)}>{this.props.confirmLabel || this.lbl('confirm')}</Button>
            <Button onClick={() => this.updateState('confirm', false)}>{this.props.cancelLabel || this.lbl('cancel')}</Button>
        </InlineWarning>
    }

    render() {
        if (this.state.confirm) return this.renderConfirm();
        return <Button onClick={() => this.updateState('confirm', true)}>{this.props.actionLabel}</Button>
    }

}

InlineActionConfirm.propTypes = {
    actionLabel: PropTypes.any,
    confirmLabel: PropTypes.any,
    confirmText: PropTypes.any,
    cancelLabel: PropTypes.any,
    onConfirm: PropTypes.func.isRequired
};

export class InlineConfirm extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            confirm: false
        }
    }

    confirm(evt) {
        this.setState({ confirm: true });

        if (this.props.onChange) this.props.onChange(this.props.type);

        evt.stopPropagation();
        evt.preventDefault();
        return false;
    }

    no() {
        if (this.props.onChange) this.props.onChange(null);
        this.setState({ confirm: false });
    }

    complete(evt) {
        this.props.onConfirm(this.props.value);
        this.setState({ loading: true });
    }

    render() {
        if (this.state.complete) {
            <Loader small />
        } else if (this.state.confirm) {
            return <div className="confirm">{this.props.confirmMsg || null}<Button isPrimary={true} onClick={this.complete.bind(this)}>{this.props.type || this.lbl('confirm')}</Button><Button onClick={this.no.bind(this)}>{this.lbl('cancel')}</Button></div>
        } else {
            if (this.props.type == 'approve') return <Button onClick={this.confirm.bind(this)}>OK</Button>
            else if (this.props.isButton) return <Button isPrimary={this.props.isPrimary} onClick={this.confirm.bind(this)}>{this.lbl('delete')}</Button>
            return <Button onClick={this.confirm.bind(this)} >X</Button>
        }
    }
}


InlineConfirm.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    value: PropTypes.any,
    onConfirm: PropTypes.func.isRequired,
    type: PropTypes.oneOf(["delete", "approve"])
};

export class InlineConfrimApproveDelete extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            selected: null
        }
    }

    onChange(selected) {
        this.setState({ ...this.state, selected });
    }

    render() {
        return <Row>
            {this.state.selected != 'approve' ?
                <InlineConfirm type="delete" onChange={this.onChange.bind(this)} value={this.props.value} onConfirm={this.props.onDelete.bind(this)} />
                : ''}
            {this.state.selected != 'delete' ?
                <InlineConfirm type="approve" onChange={this.onChange.bind(this)} value={this.props.value} onConfirm={this.props.onApprove.bind(this)} />
                : ''}
        </Row>
    }

}

InlineConfrimApproveDelete.propTypes = {
    onDelete: PropTypes.func.isRequired,
    onApprove: PropTypes.func.isRequired,
    value: PropTypes.any
}